import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const IndentIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Indent",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.44 3.56H3.56C2.7 3.56 2 4.26 2 5.12s.7 1.56 1.56 1.56h24.89c.86 0 1.56-.7 1.56-1.56s-.7-1.56-1.56-1.56ZM3.56 28.44h24.89c.86 0 1.56-.7 1.56-1.56s-.7-1.56-1.56-1.56H3.56c-.86 0-1.56.7-1.56 1.56s.7 1.56 1.56 1.56m24.88-17.63H16c-.86 0-1.56.7-1.56 1.56s.7 1.56 1.56 1.56h12.44c.86 0 1.56-.7 1.56-1.56s-.7-1.56-1.56-1.56m0 7.26H16c-.86 0-1.56.7-1.56 1.56s.7 1.56 1.56 1.56h12.44c.86 0 1.56-.7 1.56-1.56s-.7-1.56-1.56-1.56M2.93 23.12c.18.08.4.13.62.13.4 0 .77-.15 1.04-.4s6.22-5.7 6.22-5.7c.31-.29.5-.69.5-1.15s-.19-.86-.5-1.14-6.22-5.7-6.22-5.7c-.27-.25-.64-.4-1.04-.4-.85 0-1.55.69-1.56 1.54v11.41c0 .63.38 1.17.92 1.42h.01Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M28.14 7.14H3a1.14 1.14 0 1 1 0-2.28h25.14a1.14 1.14 0 1 1 0 2.28M28.14 27.71H3a1.14 1.14 0 1 1 0-2.28h25.14a1.14 1.14 0 1 1 0 2.28M28.14 14H13.28a1.14 1.14 0 1 1 0-2.28h14.86a1.14 1.14 0 1 1 0 2.28M28.14 20.86H13.28a1.14 1.14 0 1 1 0-2.28h14.86a1.14 1.14 0 1 1 0 2.28M3 20.86l4.57-4.57L3 11.71z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M3 22c-.15 0-.3-.03-.44-.09-.43-.18-.71-.59-.71-1.06v-9.14c0-.46.28-.88.71-1.06s.92-.08 1.25.25l4.57 4.57c.45.45.45 1.17 0 1.62l-4.57 4.57c-.22.22-.51.33-.81.33Zm1.14-7.53v3.62l1.81-1.81z"
      })]
    })
  }));
};
IndentIcon.displayName = 'IndentIcon';